import type { ColorKey } from '@iheartjane/reefer';
import type { Weight } from '@iheartjane/types';
import uniqBy from 'lodash-es/uniqBy';

export const LINEAGE_COLORS: Record<string, ColorKey> = {
  cbd: 'grays-mid',
  hybrid: 'grays-black',
  indica: 'grape',
  sativa: 'emerald',
};

export const FLOWERS: Weight[] = [
  { id: 'gram', label: '1g', val: 'price_gram' },
  { id: 'two_gram', label: '2g', val: 'price_two_gram' },
  { id: 'eighth_ounce', label: '3.5g', val: 'price_eighth_ounce' },
  { id: 'quarter_ounce', label: '7g', val: 'price_quarter_ounce' },
  { id: 'half_ounce', label: '14g', val: 'price_half_ounce' },
  { id: 'ounce', label: '28g', val: 'price_ounce' },
];

export const EXTRACT: Weight[] = [
  { id: 'half_gram', label: '0.5g', val: 'price_half_gram' },
  ...FLOWERS,
];

export const OTHERS: Weight[] = [
  { id: 'each', label: 'Each', val: 'price_each' },
];

export const WEIGHT_OPTIONS = uniqBy([...OTHERS, ...EXTRACT], 'id');

export const SPECIALS_GRID_LIMIT = 8;

export const REVIEWS_REQUIRED_BEFORE_DISPLAY = 5;
